import type { AiChatPrompt, AiChatPromptSetId } from '../aiChatPromptTypes';
import { investmentHoldingPrompts } from './investmentHoldingPrompt';
import { netWorthPrompts } from './netWorth';

export const aiChatPromptSets: Record<AiChatPromptSetId, AiChatPrompt[]> = {
  netWorth: netWorthPrompts,
  investmentHoldingPrompt: investmentHoldingPrompts,
  // Prompts are built from the selected insight at send time, so there is no static pool.
  wellnessInsight: [],
};
